<a [href]="url" target="_blank">{{text}}<i class="far fa-sm fa-external-link p-r-half"></i></a>
